import { useEffect } from 'react';
import useGeoLocation from '@api/hooks/useGeoLocation';
import useMobileLoginCountries from '@api/hooks/useMobileLoginCountries';
import { defaultCountry } from '@cont/Login/constants';

const useCountryInitializer = ({ setCountry }) => {
  let countries = useMobileLoginCountries();
  if (!countries.length) countries = [defaultCountry];
  const { geoLocationData: { countryCode } = {} } = useGeoLocation();
  useEffect(() => {
    if (countries?.length > 1)
      setCountry(
        countries.find((c) => c.code === countryCode) || defaultCountry
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countries.length, countryCode, setCountry]);
};

export default useCountryInitializer;
